<template>
  <div class="mini-kasko-car-type-field form-group">
    <el-select
      v-model="selectedType"
      :disabled="disabled"
      :class="{ 'mini-kasko-car-type-field--invalid': Boolean(error) }"
      placeholder="Оберіть тип авто"
      popper-class="mini-kasko-car-type-field__dropdown"
      filterable
    >
      <el-option-group
        v-for="group in autoCategoryTypes"
        :key="group.category"
        :label="group.category"
      >
        <el-option
          v-for="item in group.list"
          :key="item.id"
          :label="formatOptionLabel(group.category, item.name)"
          :value="item.id"
        />
      </el-option-group>
    </el-select>
    <small v-if="error" class="mini-kasko-order__field-error">{{ error }}</small>
  </div>
</template>

<script>
export default {
  name: 'MiniKaskoCarTypeField',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
  },
  computed: {
    autoCategoryTypes() {
      return this.$store.getters.AUTO_CATEGORY_TYPES || [];
    },
    selectedType: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    formatOptionLabel(category, name) {
      return `${category} - ${name}`;
    },
    focus() {
      this.$nextTick(() => {
        const input = this.$el.querySelector('.el-input__inner');

        if (this.$el && typeof this.$el.scrollIntoView === 'function') {
          this.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }

        if (input && typeof input.focus === 'function') {
          input.focus();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mini-kasko-car-type-field {
  width: 100%;

  .mini-kasko-order__field-error {
    color: #dc2626;
    font-size: 12px;
    line-height: 16px;
  }

  ::v-deep .el-select {
    width: 100%;
  }

  ::v-deep .el-input__inner {
    width: 100%;
    min-height: 44px;
    height: 44px;
    padding: 10px 36px 10px 12px;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    background: #fff;
    color: inherit;
    font: inherit;
    box-shadow: none;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  ::v-deep .el-input__inner::placeholder {
    font: inherit;
    color: #71717a;
  }

  ::v-deep .el-input__inner,
  ::v-deep .el-input__icon,
  ::v-deep .el-select__caret {
    line-height: inherit;
  }

  ::v-deep .el-input,
  ::v-deep .el-select,
  ::v-deep .el-select__caret,
  ::v-deep .el-input__suffix,
  ::v-deep .el-input__suffix-inner {
    color: inherit;
    font: inherit;
  }

  ::v-deep .el-input.is-focus .el-input__inner,
  ::v-deep .el-select .el-input__inner:focus {
    border-color: #fb923c;
    box-shadow: 0 0 0 3px rgba(251, 146, 60, 0.15);
  }

  ::v-deep .el-input.is-disabled .el-input__inner {
    background: #f8fafc;
    color: #52525b;
    cursor: default;
  }

  ::v-deep .el-input__suffix {
    display: flex;
    align-items: center;
    right: 12px;
  }

  ::v-deep .el-input__suffix-inner {
    display: flex;
    align-items: center;
  }

  ::v-deep .el-select__caret {
    color: #71717a;
    font-size: 14px;
  }

  &--invalid {
    ::v-deep .el-input__inner {
      border-color: #ef4444;
    }

    ::v-deep .el-input.is-focus .el-input__inner,
    ::v-deep .el-select .el-input__inner:focus {
      border-color: #ef4444;
      box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.12);
    }
  }
}
</style>

<style lang="scss">
.mini-kasko-car-type-field__dropdown {
  .el-scrollbar__view {
    padding: 8px;
  }

  .el-select-group {
    margin-bottom: 8px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
    background: #fff;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .el-select-group__wrap:not(:last-of-type)::after {
    display: none;
  }

  .el-select-group__title {
    display: flex;
    align-items: center;
    min-height: 38px;
    padding: 8px 12px;
    background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
    border-bottom: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #334155;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .el-select-group .el-select-dropdown__item {
    padding-left: 16px;
    padding-right: 16px;
  }

  .el-select-group .el-select-dropdown__item.hover,
  .el-select-group .el-select-dropdown__item:hover {
    background: #fff7ed;
    color: #9a3412;
  }

  .el-select-group .el-select-dropdown__item.selected {
    background: #ffedd5;
    color: #9a3412;
    font-weight: 600;
  }

  .el-select-dropdown__item,
  .el-select-dropdown__empty {
    color: inherit;
    font: inherit;
    align-content: center;
  }
}
</style>
